import * as React from 'react'
import { Box, useTheme, useMediaQuery } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { type Chip, CHIP_LABEL, CHIP_ICON, type ChipRow, type ChipType } from 'types/fpl/chips'
import { formatDecimal } from '../../utils/numbers'

interface Props {
  chips: Chip[]
  loading?: boolean
  totalTeams: number
}

const ChipsGrid: React.FC<Props> = ({ chips, loading, totalTeams }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))


  const rows: ChipRow[] = chips.map((c) => {
    return {
      id: c.chip,
      chip: c.chip,
      chipLabel: CHIP_LABEL[c.chip],
      count: c.count,
      percentage: totalTeams ? formatDecimal((c.count / totalTeams) * 100) : 0
    }
  })

  const columns: GridColDef<ChipRow>[] = [
    {
        field: 'chipLabel',
        headerName: 'Chip',
        flex: 1,
        minWidth: isMobile ? 100 : 140,
        align: 'left',
        headerAlign: 'center',
        renderCell: (params) => {
          const icon = CHIP_ICON[params.row.chip as ChipType]
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {icon && <img src={icon} alt={params.value} style={{ width: isMobile ? 16 : 24, height: isMobile ? 16 : 24, objectFit: 'contain' }} />}
              <span style={{ fontFamily: 'PremierLeagueBold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{params.value}</span>
            </Box>
          )
        },
    },
    {
        field: 'count',
        headerName: 'Used',
        width: isMobile ? 100 : 110,
        align: 'center',
        headerAlign: 'center',
        type: 'number',
        renderCell: (params) => (
        <span style={{ fontFamily: 'PremierLeagueBold', fontSize: isMobile ? '0.75rem' : '0.875rem' }}>{params.value}</span>
      )
    },
    {
        field: 'percentage',
        headerName: 'Used %',
        width: isMobile ? 90 : 98,
        align: 'center',
        headerAlign: 'center',
        type: 'number',
        valueFormatter: (p) => `${p.value}%`,
    }
  ]

  return (
    <Box
        sx={{
            width: '100%',
            pb: 1,
            '& .MuiDataGrid-columnHeaders': { 
              fontFamily: 'PremierLeagueBold',
              fontSize: isMobile ? '0.75rem' : '0.875rem',
            },
            '& .MuiDataGrid-cell': { 
              fontFamily: 'PremierLeagueRegular',
              fontSize: isMobile ? '0.75rem' : '0.875rem',
            },
            '& .MuiDataGrid-root': {
              fontSize: isMobile ? '0.75rem' : '0.875rem',
            },
    }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        disableSelectionOnClick
        hideFooter
        sortingOrder={['desc', 'asc']}
        autoHeight
        initialState={{sorting: { sortModel: [{ field: 'count', sort: 'desc' }] }}}
        rowHeight={isMobile ? 36 : 44}
      />
    </Box>
  )
}

export default ChipsGrid
